var _path, _mask, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmployeeSlotBreakPlot = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M12.5 5.55v6.556c0 1.348-.958 2.444-2.123 2.444H5.622c-.412 0-.8-.14-1.128-.393-.593-.422-.994-1.18-.994-2.05V5.55h9z",
  stroke: "#7E7E7E",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "b37ltqotaa",
  maskUnits: "userSpaceOnUse",
  x: 12,
  y: 7,
  width: 4,
  height: 6,
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 7h4v6h-4z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.019 8c1.113.095 1.981.955 1.981 2.005 0 1.05-.877 1.91-2 1.995"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.104 7.004a1 1 0 0 0-.17 1.992l.17-1.992zm-.18 3.999a1 1 0 1 0 .152 1.994l-.152-1.994zm.01-2.007c.669.058 1.066.55 1.066 1.01h2c0-1.64-1.339-2.869-2.896-3.002l-.17 1.992zM14 10.006c0 .451-.396.945-1.076.997l.152 1.994c1.566-.12 2.924-1.344 2.924-2.992h-2z",
  fill: "#7E7E7E",
  mask: "url(#b37ltqotaa)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 3.276c.305-.787 1.223-1.191 2.05-.9l1.498.525c.829.29 1.746-.114 2.052-.901",
  stroke: "#7E7E7E",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmployeeSlotBreakPlot);
export default ForwardRef;